import React from 'react';
import { Form, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import Button from '../button';

const Filter = ({
  filters = [],
  onFilter,
  onReset,
  loading = false,
  className = '',
  style = {},
  ...props
}) => {
  const [form] = Form.useForm();

  const handleReset = () => {
    form.resetFields();
    onReset?.();
  };

  const handleFilter = (values) => {
    onFilter?.(values);
  };

  return (
    <Form
      form={form}
      onFinish={handleFilter}
      className={`custom-filter ${className}`}
      style={{
        padding: '16px',
        background: '#fff',
        borderRadius: '8px',
        ...style
      }}
      {...props}
    >
      <Row gutter={[16, 16]}>
        {filters.map((filter, index) => (
          <Col key={index} {...filter.colProps}>
            {filter.render(form)}
          </Col>
        ))}
        <Col>
          <Button type="primary" htmlType="submit" loading={loading}>
            Filtrar
          </Button>
        </Col>
        <Col>
          <Button onClick={handleReset}>Limpar</Button>
        </Col>
      </Row>
    </Form>
  );
};

Filter.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      render: PropTypes.func.isRequired,
      colProps: PropTypes.object
    })
  ),
  onFilter: PropTypes.func,
  onReset: PropTypes.func,
  loading: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};

export default Filter; 